import { createBrowserRouter } from "react-router-dom";
import Agenda from "./pages/Agenda/Agenda";
import Contato from "./pages/Contato/Contato";
import Historia from "./pages/Historia/Historia";
import Inicio from "./pages/Inicio/Inicio";
import Musicas from "./pages/Musicas/Musicas";
import { Outlet } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/footer";
import LinkBio from "./pages/LinkBio/linkbio";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const router = createBrowserRouter([
    {
      element: <Layout/>,
      children: [      
        
          {path : '/', element: <Inicio/>},
          {path : '/agenda', element: <Agenda backgroundImage = '/maracaju_05.jpg' />},
          {path : '/contato', element: <Contato backgroundImage = '/maracaju_03.jpg'/>},
          {path : '/historia', element: <Historia />},
          {path : '/musicas', element: <Musicas backgroundImage = '/maracaju_04.jpg'/>},
      ]
    },{
      element: <NoHeaderFooterLayout/>,
      children: [      
          {path : '/link-bio', element: <LinkBio />}
      ]
    }
  ])


function Layout() {
  return (
    <>
      <Header/>
      <ScrollToTop/>
      <main>
        <Outlet />
      </main>
      <Footer className='footer'/>
    </>
  );
}

function NoHeaderFooterLayout() {
  return (
    <>
        <Outlet />
    </>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}